import type { TTeamMetricId } from './types';

type TEntradaDeMetrica = {
  id: TTeamMetricId;
  token: string;
  display: 'BAR' | 'STAT';
};

const TABLA_DEL_CONTRATO: readonly TEntradaDeMetrica[] = [
  {
    id: 'equipo_avance_pct',
    token: 'leader_average_team_advance',
    display: 'BAR',
  },
  {
    id: 'equipo_completados_pct',
    token: 'leader_completed_courses',
    display: 'BAR',
  },
  { id: 'equipo_activos_pct', token: 'leader_weekly_activity', display: 'BAR' },
  { id: 'equipo_meta_pct', token: 'leader_goal_completion', display: 'BAR' },
  {
    id: 'equipo_sin_iniciar_pct',
    token: 'leader_users_not_started',
    display: 'STAT',
  },
  { id: 'equipo_riesgo_pct', token: 'leader_users_at_risk', display: 'STAT' },
  {
    id: 'equipo_horas_prom',
    token: 'leader_training_hours_per_person',
    display: 'STAT',
  },
  {
    id: 'equipo_cursos_prom',
    token: 'leader_courses_per_person',
    display: 'STAT',
  },
];

export const METRICA_POR_ID = new Map<TTeamMetricId, TEntradaDeMetrica>(
  TABLA_DEL_CONTRATO.map(entrada => [entrada.id, entrada]),
);

export const METRICA_POR_TOKEN = new Map<string, TEntradaDeMetrica>(
  TABLA_DEL_CONTRATO.map(entrada => [entrada.token, entrada]),
);

export class MetricaSinTokenDelContrato extends Error {
  constructor(metricId: string) {
    super(`Metric ${metricId} has no token in the contract table`);
    this.name = 'MetricaSinTokenDelContrato';
  }
}
